import { axiosInstance } from './axios-instance';
import type { DriveFolderContents, DriveFilePreview } from '../types/drive';

const DRIVE_BASE = '/drive';

export const driveApi = {
  listFolder: async (
    folderId: string,
    pageToken?: string
  ): Promise<DriveFolderContents> => {
    const params: Record<string, string> = {};
    if (pageToken) params.page_token = pageToken;

    const res = await axiosInstance.get(
      `${DRIVE_BASE}/folders/${encodeURIComponent(folderId)}/contents`,
      { params }
    );
    return res.data?.data ?? res.data;
  },

  getPreview: async (fileId: string): Promise<DriveFilePreview> => {
    const res = await axiosInstance.get(
      `${DRIVE_BASE}/files/${encodeURIComponent(fileId)}/preview`
    );
    return res.data?.data ?? res.data;
  },

  getDownloadUrl: (fileId: string): string => {
    const base = axiosInstance.defaults.baseURL ?? '';
    return `${base}${DRIVE_BASE}/files/${encodeURIComponent(fileId)}/download`;
  },

  getExportPdfUrl: (fileId: string): string => {
    const base = axiosInstance.defaults.baseURL ?? '';
    return `${base}${DRIVE_BASE}/files/${encodeURIComponent(fileId)}/export-pdf`;
  },

  /** Fetch file as blob via axios (sends Accept header); use for download/iframe/img to avoid 406. */
  downloadFileBlob: async (fileId: string, token?: string): Promise<Blob> => {
    const res = await axiosInstance.get(
      `${DRIVE_BASE}/files/${encodeURIComponent(fileId)}/download`,
      { params: token ? { token } : undefined, responseType: 'blob' }
    );
    return res.data as Blob;
  },

  /** Fetch export-pdf as blob via axios (sends Accept header). */
  getExportPdfBlob: async (fileId: string, token?: string): Promise<Blob> => {
    const res = await axiosInstance.get(
      `${DRIVE_BASE}/files/${encodeURIComponent(fileId)}/export-pdf`,
      { params: token ? { token } : undefined, responseType: 'blob' }
    );
    return res.data as Blob;
  },
};
